module.exports = __webpack_public_path__ + "img/6_asia.8e14892e.png";